module.exports = __webpack_public_path__ + "static/media/footer-icons@2x.dcbd3930.jpg";